// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1lGLZ","options":"AnswerScale_options__1oTXM","selected":"AnswerScale_selected__3jEz0"};